<template>
  <div class="container">
    <!-- 서브상단영역 -->

    <Banner
      title=""
      subtitle=""
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />
    <!-- //서브상단영역 -->
    <!-- 메뉴 -->
    <!--<div class="sub_layout_nav dis_desktop">
	<div>
		<div class="home"><span class="icon-home"></span></div>
		<div class="deps1"></div>
		<div class="deps2">
			회원가입			<span class="icon-chevron-thin-down on"></span>
			<span class="icon-chevron-thin-up"></span>
			<ul class="deps2_nav">
							</ul>
		</div>
	</div>
</div>-->
    <!-- //메뉴 -->
    <div class="width_wrap">
      <div class="body_content">
        <!-- 서브 타이틀영역 -->
        <h1 class="sub_subject">회원가입<span></span></h1>
        <!-- //서브 타이틀영역 -->

        <div class="glores-B-join-complete">
          <div class="glores-B-join-step">
            <ol>
              <li><span>01 약관동의</span></li>
              <li><span>02 정보입력</span></li>
              <li class="on"><span>03 가입완료</span></li>
            </ol>
          </div>

          <div class="glores-B-join-title">
            <h3 class="join-title">가입완료</h3>
          </div>

          <div class="glores-B-join-msg">
            <p class="glores-B-msg-text1">
              <span>반갑습니다.</span>
              <strong class="msg-id">"{{ registeredId }}"</strong>
              <span>고객님!</span><br />
              <span>회원 가입이 완료 되었습니다.</span>
            </p>

            <p class="glores-B-msg-text2">
              <span
                >회원님은 저희 사이트에서 제공하는 모든 서비스와 이벤트를
                편리하게 이용하실 수 있습니다.</span
              ><br />
              'COKOLab. Inc.'는 최고의 사이트가 되기 위해 최선의 노력을
              다하겠습니다.
              <span class="glores-B-text-thx">감사합니다.</span>
            </p>
          </div>

          <div class="glores-B-btn-wrap glores-B-m-half">
            <div class="btn-cell">
              <router-link
                :to="`${USER_ROUTES.Home.Path}`"
                class="glores-B-btn-type1 glores-B-large glores-B-m-full-width"
                >메인화면</router-link
              >
            </div>
            <div class="btn-cell">
              <router-link
                :to="`${USER_ROUTES.Login.Path}`"
                class="glores-B-btn-type1 glores-B-large glores-B-m-full-width glores-B-highlight"
                >로그인</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRoute } from "vue-router";
import { ref, onMounted } from "vue";

const route = useRoute();
const registeredId = ref<string>("");

onMounted(() => {
  const idParam = route.params.id;
  if (typeof idParam === "string") {
    registeredId.value = idParam;
  }
});
</script>

<style scoped>
.glores-B-join-msg {
  padding: 70px 15px 30px;
  border-bottom: 1px solid #ededed;
  background: url("@/assets/img_up/shop_pds/kp708b/design/glores_b/bg_join_comp.png")
    no-repeat center 15px;
  background-size: 39px auto;
}

@media all and (min-width: 1024px) {
  .glores-B-join-msg {
    padding: 150px 30px 60px;
    background-position: center 40px;
    background-size: auto;
  }
}
</style>
